export default function () {
  this.route('siwe-auth', { path: '/discourse-siwe/auth' }, function () {
    this.route('index', { path: '/' })
  })
}

import deprecated_gjYVqPLMxe from "discourse/lib/deprecated";
deprecated_gjYVqPLMxe(
  "The file 'discourse/siwe-route-map.js.es6' uses the deprecated `.js.es6` extension. Use `.js` instead.",
  {
    id: "discourse.es6-extension",
    url: "https://meta.discourse.org/t/398894",
  }
);
